
import { useNavigate } from 'react-router-dom';
import { recentlyPlayed } from '../../../mocks/musicData';

interface RecentlyPlayedProps {
  onTrackSelect: (track: any, trackList: any[]) => void;
}

export default function RecentlyPlayed({ onTrackSelect }: RecentlyPlayedProps) {
  const navigate = useNavigate();

  const handlePlayTrack = (track: any) => {
    onTrackSelect(track, recentlyPlayed);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Recently Played</h2>
            <p className="text-gray-600">Pick up where you left off</p>
          </div>
          <button 
            onClick={() => navigate('/library')}
            className="text-purple-600 hover:text-purple-700 font-medium cursor-pointer whitespace-nowrap"
          >
            View History
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          {recentlyPlayed.map((track) => (
            <div 
              key={track.id}
              className="bg-gray-50 rounded-xl p-4 hover:bg-gray-100 transition-all duration-200 cursor-pointer group"
            >
              <div className="relative mb-3">
                <img 
                  src={track.imageUrl}
                  alt={track.title}
                  className="w-full aspect-square rounded-lg object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 rounded-lg transition-all duration-300 flex items-center justify-center">
                  <button 
                    onClick={() => handlePlayTrack(track)}
                    className="w-10 h-10 bg-purple-600 text-white rounded-full opacity-0 group-hover:opacity-100 transform scale-75 group-hover:scale-100 transition-all duration-300 flex items-center justify-center"
                  >
                    <i className="ri-play-fill text-sm"></i>
                  </button>
                </div>
              </div>
              
              <h4 className="font-medium text-gray-900 text-sm mb-1 truncate">{track.title}</h4>
              <p className="text-xs text-gray-600 mb-2 truncate">{track.artist}</p>
              <p className="text-xs text-gray-400">{track.playedAt}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
